import { type Control, Controller } from "react-hook-form";

import RenderIf from "common/components/RenderIf";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import Switch from "common/components/ui/Switch";

import type { WebhookFormType } from "../../../schema";

interface WebhookHeaderProps {
  isProtected: boolean;
  setIsProtected: (value: boolean) => void;
  control: Control<WebhookFormType>;
}

export default function WebhookHeader({
  isProtected,
  setIsProtected,
  control,
}: WebhookHeaderProps) {
  return (
    <section className="mb-4">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h5 className="mb-2 text-button-sm text-black-700">
            Protect webhook URL with basic authentication
          </h5>
          <p className="text-black-700">
            Allows you to add a username and password to secure your webhook URL
          </p>
        </div>

        <Switch checked={isProtected} onCheckedChange={setIsProtected} />
      </div>

      <RenderIf condition={isProtected}>
        <div className="flex gap-4 border-black-200 animate-in fade-in-0 max-lg:flex-col max-lg:pt-4 lg:grid lg:grid-cols-2 lg:border-b lg:py-4">
          <Controller
            name="headers.name"
            control={control}
            render={({
              field: { onChange, value, name },
              fieldState: { error },
            }) => (
              <FormField
                label="Header name"
                htmlFor="headers.name"
                error={error?.message}
              >
                <Input
                  name={name}
                  value={value}
                  onChange={(e) => onChange(e)}
                  placeholder="Enter headers name"
                />
              </FormField>
            )}
          />
          <Controller
            name="headers.value"
            control={control}
            render={({
              field: { onChange, value, name },
              fieldState: { error },
            }) => (
              <FormField
                label="Header value"
                htmlFor="headers.value"
                error={error?.message}
              >
                <Input
                  name={name}
                  value={value}
                  onChange={(e) => onChange(e)}
                  placeholder="Enter headers value"
                />
              </FormField>
            )}
          />
        </div>
      </RenderIf>
    </section>
  );
}
